import Vue from 'vue';
import moment from 'moment';
import table from '../../components/console-common/table.vue';
import commonVideo from '../../components/console-common/common-video.vue';
import { toYuan } from '../../utils/unit-conversion';
export default Vue.extend({
    name: 'balanceAccountOverview',
    components: {
        'el-repayment-list': table,
        'el-common-video': commonVideo,
    },
    data: function () {
        return {
            withdrawStatus: '',
            applyTimeStart: '',
            applyTimeEnd: '',
            withdrawOptions: [
                {
                    label: '提现中',
                    val: 'APPLIED',
                },
                {
                    label: '提现成功',
                    val: 'SUCCESS',
                },
                {
                    label: '提现失败',
                    val: 'FAIL',
                },
            ],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick: function (picker) {
                            var today = new Date();
                            var lastWeek = new Date(today.getTime() - 3600 * 1000 * 24 * 6);
                            picker.$emit('pick', [lastWeek, today]);
                        },
                    },
                    {
                        text: '最近一个月',
                        onClick: function (picker) {
                            var today = new Date();
                            var lastMonth = new Date(today.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [lastMonth, today]);
                        },
                    },
                    {
                        text: '最近三个月',
                        onClick: function (picker) {
                            var today = new Date();
                            var lastQuarter = new Date(today.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [lastQuarter, today]);
                        },
                    },
                ],
            },
            dateArr: [],
            otherParam: {},
            cardData: [
                {
                    tit: '可用余额',
                    des: '可用于司机补款奖励/提现的金额',
                    money: 0,
                    btn: true,
                    use: true,
                },
                {
                    tit: '处理中金额',
                    des: '今日司机还款金额，次日结算到可用余额',
                    money: 0,
                },
            ],
            exportConfig: {
                fileName: '还款明细列表',
                keyUrl: '/proxy/api/account/withdraw/export',
                statusUrl: '/proxy/api/getFileUrl',
                statusKeys: 'fileGiftKey',
            },
            requestConfig: {
                url: '/proxy/api/account/withdraw/page',
                method: 'post',
            },
            tableConfig: [
                {
                    label: '申请提现时间',
                    prop: 'time',
                    formatter: function (val) {
                        return moment(val).format('YYYY-MM-DD HH:mm:ss');
                    },
                },
                {
                    label: '流水号',
                    prop: 'orderId',
                    tooltip: true,
                    width: '200px',
                },
                {
                    label: '金额(元)',
                    align: 'right',
                    prop: 'amount',
                    width: '100px',
                    formatter: function (val) {
                        return toYuan(val).toFixed(2);
                    },
                },
                {
                    label: '结算账户',
                    prop: 'bankName',
                    width: '180px',
                    formatter: function (val, row) {
                        return row.bankName + "(" + row.cardNo + ")";
                    },
                },
                {
                    label: '提现状态',
                    prop: 'status',
                    tooltip: true,
                    width: '320px',
                    filters: [
                        {
                            text: '提现中',
                            value: 'APPLIED',
                        },
                        {
                            text: '提现成功',
                            value: 'SUCCESS',
                        },
                        {
                            text: '提现失败',
                            value: 'FAIL',
                        },
                        {
                            text: '退单不付',
                            value: 'REFUND',
                        },
                    ],
                    formatter: function (val, row) {
                        var change = {
                            APPLIED: '提现中',
                            SUCCESS: '提现成功',
                            FAIL: '提现失败',
                            REFUND: '退单不付',
                        };
                        return row.resultDesc
                            ? change[val] + "(" + row.resultDesc + ")"
                            : change[val];
                    },
                },
            ],
            cellConfig: {
                status: [
                    {
                        status: 'FAIL',
                        style: 'color:#FF5257',
                    },
                ],
            },
        };
    },
    created: function () {
        this.getBalance();
    },
    methods: {
        getDate: function (val) {
            if (val instanceof Array && val.length > 0) {
                this.applyTimeStart = moment(val[0]).format('YYYY-MM-DD');
                this.applyTimeEnd = moment(val[1]).format('YYYY-MM-DD');
            }
            else {
                this.applyTimeStart = '';
                this.applyTimeEnd = '';
            }
            this.updateOtherParams();
        },
        updateStatus: function (val) {
            this.withdrawStatus = val;
            this.updateOtherParams();
        },
        updateOtherParams: function () {
            var _a = this, applyTimeStart = _a.applyTimeStart, applyTimeEnd = _a.applyTimeEnd, withdrawStatus = _a.withdrawStatus;
            this.otherParam = {
                applyTimeStart: applyTimeStart,
                applyTimeEnd: applyTimeEnd,
                status: withdrawStatus,
            };
        },
        getBalance: function () {
            var _this = this;
            this.$request({
                url: 'proxy/api/account/balance',
                method: 'post',
                data: {},
            }).then(function (res) {
                if (!res || res.errorCode) {
                    return;
                }
                var _a = res.data, total = _a.total, draw = _a.draw;
                var able = toYuan(draw);
                var unable = toYuan(total - draw);
                _this.cardData[0].money = able;
                _this.cardData[1].money = unable;
            });
        },
        withdraw: function () {
            this.$router.push({ name: 'balanceSure' });
        },
    },
});
